export const addClass = (element, classList) => {
  let classNames = classList;
  if (Array.isArray(classList) === false) {
    classNames = [classNames];
  }
  classNames.forEach((c) => element.classList.add(c));
};

export const removeClass = (element, classList) => {
  let classNames = classList;
  if (Array.isArray(classList) === false) {
    classNames = [classNames];
  }
  classNames.forEach((c) => element.classList.remove(c));
};

export default {
  addClass,
  removeClass,
};
